import request from '../index';
/** 和品宣部有关的接口 **/

/** 
* ProductInfo
* @params {string} data.catalog 目录
* @params {string} data.content 文本框
* @params {number} data.id 
* @params {boolean} data.isDeactivate 是否停用
* @params {string} data.model 型号
* @params {string} data.picture 图片
* @params {string} data.product 产品
* @params {number} data.pv 
* @params {number} data.sharingFrequency 分享次数
* @params {string} data.updateTime 更新时间
* @params {string} data.video 视频
*/

/** 
* 增加产品资料浏览量
* @params {number} params.productInfoId 产品资料id
*/
export const addProductInfoPV = (params) => request.get('/api-qc/addProductInfoPV', { params });

/** 
* 删除产品资料
* @params {array} ids
*/
export const deleteProductInfo = (data) => request.delete('/api-qc/deleteProductInfo', { data });

/** 
* 删除产品资料附件
* @params {array} pathList
*/
export const deleteProductInfoAnnex = (data) => request.delete('/api-qc/deleteProductInfoAnnex', { data });

/** 
* 获得产品资料列表
* @params {string} params.catalog 目录
* @params {string} params.model 型号
* @params {string} params.product 产品
*/
export const getProductInfoList = (params) => request.get('/api-qc/getProductInfoList', { params });

/** 
* 添加or更新产品资料
* @params {ProductInfo} productInfo
*/
export const saveProductInfo = (data) => request.post('/api-qc/saveProductInfo', data);

/** 
* 同步产品资料浏览量
*/
export const syncProductInfoPV = (params) => request.get('/api-qc/syncProductInfoPV', { params });

/** 
* 上传产品资料附件
*/
export const uploadProductInfo = (data) => request.post('/api-qc/uploadProductInfo', data);

/**
 * 上传彩页
*/
export const uploadColorPageFile = (data) => request.post('/api-qc/uploadColorPageFile', data);

/**
 * 获得产品资料详情
*/
export const getOne = (params) => request.get('/api-qc/getOne', { params });
